var map = {
	"./2567/Agricultural/index.jsx": 2263,
	"./2567/Degitech/index.jsx": 9243,
	"./2567/Dentistry/index.jsx": 1248,
	"./2567/Engineering/index.jsx": 6818,
	"./2567/Medicine/index.jsx": 9336,
	"./2567/Nursing/index.jsx": 8818,
	"./2567/PublicHealth/index.jsx": 3019,
	"./2567/Science/index.jsx": 523,
	"./2567/Social/index.jsx": 9056,
	"./2568/Agricultural/index.jsx": 6078,
	"./2568/Degitech/index.jsx": 9102,
	"./2568/Dentistry/index.jsx": 7637,
	"./2568/Engineering/index.jsx": 5479,
	"./2568/Medicine/index.jsx": 9791,
	"./2568/Nursing/index.jsx": 9277,
	"./2568/PublicHealth/index.jsx": 1419,
	"./2568/Science/index.jsx": 1862,
	"./2568/Social/index.jsx": 384,
	"./2569/Agricultural/index.jsx": 7821,
	"./2569/Degitech/index.jsx": 5450,
	"./2569/Dentistry/index.jsx": 3791,
	"./2569/Engineering/index.jsx": 1167,
	"./2569/Medicine/index.jsx": 4940,
	"./2569/Nursing/index.jsx": 670,
	"./2569/PublicHealth/index.jsx": 8914,
	"./2569/Science/index.jsx": 3919,
	"./2569/Social/index.jsx": 1915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;